import { useSearchOnce } from "../../useSearchOnce";
import type { CheckoutReturn } from "./BillingCard";

export type CheckoutSearch = { checkout?: CheckoutReturn; back?: string };

const returns: readonly CheckoutReturn[] = ["success", "cancelled"];

/** Reads how Stripe's payment page sent the person back, if it did, and the page of the app the offers were opened
 * from: a path of the app, never another site's address. */
export function validateCheckoutSearch(search: Record<string, unknown>): CheckoutSearch {
  const checkout = returns.find((value) => value === search["checkout"]);
  if (checkout === undefined) {
    return {};
  }
  const back = search["back"];
  return typeof back === "string" && isAppPath(back) ? { checkout, back } : { checkout };
}

function isAppPath(path: string): boolean {
  return path.startsWith("/") && !path.startsWith("//") && !path.startsWith("/\\");
}

/** Keeps how the payment page sent the person back, and takes it out of the address. */
export function useCheckoutReturn(search: CheckoutSearch): CheckoutReturn | undefined {
  return useSearchOnce(search.checkout);
}

/** Keeps the page to go back to after the payment page, and takes it out of the address. */
export function useCheckoutBack(search: CheckoutSearch): string | undefined {
  return useSearchOnce(search.back);
}
